export const businessSkillsActionTypes = {
    ADD_CATEGORY: "ADD_CATEGORY",
    REMOVE_CATEGORY: "REMOVE_CATEGORY",
    MOVE_CATEGORY_UP: "MOVE_CATEGORY_UP",
    MOVE_CATEGORY_DOWN: "MOVE_CATEGORY_DOWN",
    // There is no CHANGE_CATEGORY
    ADD_COMPETENCE: "ADD_COMPETENCE",
    REMOVE_COMPETENCE: "REMOVE_COMPETENCE",
    CHANGE_COMPETENCE: "CHANGE_COMPETENCE",
    MOVE_COMPETENCE_UP: "MOVE_COMPETENCE_UP",
    MOVE_COMPETENCE_DOWN: "MOVE_COMPETENCE_DOWN",
}

export function businessSkillsReducer( businessSkills, action ) {
    let currentOrder = action.item.order;
    let parentOrder = action.parentOrder || 0;
    let updatedBusinessSkills;

    switch ( action.type ) {
        case businessSkillsActionTypes.ADD_CATEGORY:
            updatedBusinessSkills = [
                ...businessSkills, {
                    order: businessSkills.length,
                    category: {
                        ...action.item
                    },
                    competences: [],
                }
            ];
            break;

        case businessSkillsActionTypes.REMOVE_CATEGORY:
            updatedBusinessSkills = businessSkills
                .filter( competenceCategory => competenceCategory.order !== action.item.order )
                .sort( ( a, b ) => a.order - b.order )
                .map( ( category, index ) => {
                    category.order = index;
                    return category;
                } );
            break;

        case businessSkillsActionTypes.MOVE_CATEGORY_UP:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === currentOrder ) {
                        competenceCategory.order--;
                    } else if ( competenceCategory.order === currentOrder - 1 ) {
                        competenceCategory.order++;
                    }
                    return competenceCategory
                } );
            break;

        case businessSkillsActionTypes.MOVE_CATEGORY_DOWN:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === currentOrder ) {
                        competenceCategory.order++;
                    } else if ( competenceCategory.order === currentOrder + 1 ) {
                        competenceCategory.order--;
                    }
                    return competenceCategory
                } );
            break;

        case businessSkillsActionTypes.ADD_COMPETENCE:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === parentOrder ) {
                        if ( !competenceCategory.competences ) {
                            competenceCategory.competences = [];
                        }
                        return {
                            ...competenceCategory,
                            competences: [
                                ...competenceCategory.competences,
                                {
                                    ...action.item,
                                    order: competenceCategory.competences.length,
                                }
                            ].sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return competenceCategory;
                    }
                } );
            break;

        case businessSkillsActionTypes.REMOVE_COMPETENCE:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === parentOrder ) {
                        return {
                            ...competenceCategory,
                            competences: competenceCategory.competences
                                .filter( competence => competence.order !== action.item.order )
                                .sort( ( a, b ) => a.order - b.order )
                                .map( ( competence, index ) => {
                                    competence.order = index;
                                    return competence;
                                } )
                        }
                    } else {
                        return competenceCategory;
                    }
                } );
            break;

        case businessSkillsActionTypes.CHANGE_COMPETENCE:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === parentOrder ) {
                        return {
                            ...competenceCategory,
                            competences: competenceCategory.competences
                                .map( competence => {
                                    if ( competence.order === action.item.order ) {
                                        return action.item;
                                    } else {
                                        return competence;
                                    }
                                } )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return competenceCategory;
                    }
                } );
            break;

        case businessSkillsActionTypes.MOVE_COMPETENCE_UP:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === parentOrder ) {
                        return {
                            ...competenceCategory,
                            competences: competenceCategory.competences
                                .map(
                                    competence => {
                                        if ( competence.order === currentOrder ) {
                                            competence.order--;
                                        } else if ( competence.order === currentOrder - 1 ) {
                                            competence.order++;
                                        }
                                        return competence
                                    }
                                )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return competenceCategory;
                    }

                } );
            break;

        case businessSkillsActionTypes.MOVE_COMPETENCE_DOWN:
            updatedBusinessSkills = businessSkills
                .map( competenceCategory => {
                    if ( competenceCategory.order === parentOrder ) {
                        return {
                            ...competenceCategory,
                            competences: competenceCategory.competences
                                .map(
                                    competence => {
                                        if ( competence.order === currentOrder ) {
                                            competence.order++;
                                        } else if ( competence.order === currentOrder + 1 ) {
                                            competence.order--;
                                        }
                                        return competence
                                    }
                                )
                                .sort( ( a, b ) => a.order - b.order )
                        }
                    } else {
                        return competenceCategory;
                    }

                } );
            break;

        default: {
            throw new Error( `Unknown action: [${ action.type }]` );
        }
    }
    return updatedBusinessSkills.sort( ( a, b ) => a.order - b.order );
}
